import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DialogPayload, Overlays } from '../types/redux.types';
import { v4 as generateId } from 'uuid';
import { differsBy } from 'src/utils/functions/compareObjects';

const initialState: Overlays = {
  dialogs: [],
};

const dialogs = createSlice({
  name: 'dialogs',
  initialState,
  reducers: {
    openDialog(state, { payload }: PayloadAction<any>) {
      const dialog = {
        ...payload,
        id: generateId(),
      };

      state['dialogs'] = [...state.dialogs, dialog];
    },
    closeDialog(state, { payload }: PayloadAction<any>) {
      const dialogId = payload;
      const filteredDialogs = state.dialogs.filter(differsBy({ id: dialogId }));

      state['dialogs'] = filteredDialogs;
    },

    closeLastDialog(state) {
      const filteredDialogs = state.dialogs.slice(0, state.dialogs.length - 1);
      state['dialogs'] = filteredDialogs;
    },
  },
});

export const { openDialog, closeDialog, closeLastDialog } = dialogs.actions;

export default dialogs.reducer;
